import * as Yup from 'yup';

export default function getSchemaValidation(type) {
  let optionalRules = {};

  if (type === 'cnpj') {
    optionalRules = {
      razaoSocial: Yup.string().required(
        'Insira a razão social do estabelecimento',
      ),
    };
  }

  const rules = {
    telefone: Yup.string()
      .required('Insira um número de telefone válido')
      .matches(
        /\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/,
        'Insira um número de telefone válido',
      ),
    cep: Yup.string()
      .required('Insira um CEP válido')
      .matches(/[0-9]{5}-[0-9]{3}/, 'Insira um CEP válido'),
    nomeFantasia: Yup.string().required('Insira o nome do estabelecimento'),
    endereco: Yup.string().required('Insira o endereço do estabelecimento'),
    numero: Yup.string().required('Insira o número'),
    bairro: Yup.string().required('Insira o bairro'),
    cidade: Yup.string().required('Insira a cidade do estabelecimento'),
    estado: Yup.string().required('Informe a UF'),
    categoria: Yup.string().required('Selecione uma categoria'),
    ...optionalRules,
  };

  return Yup.object().shape(rules);
}
